import { render, staticRenderFns } from "./ot-button.vue?vue&type=template&id=2be9daca&scoped=true&"
import script from "./ot-button.vue?vue&type=script&lang=ts&"
export * from "./ot-button.vue?vue&type=script&lang=ts&"
import style0 from "./ot-button.vue?vue&type=style&index=0&id=2be9daca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be9daca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VIcon,VProgressCircular})
